import { createUseStyles } from 'react-jss'
import { colors, zIndexes } from '#base/js/variables.style'

const actionsAreaHeight = 32
export const blockHighlight = {
  margin: 0,
  border: `thin solid ${colors.brandAccent}`
}

export const style = {
  actionsWrapper: {
    scrollMarginTop: '32px',
    position: 'relative',
    '&:hover $actionsArea': {
      visibility: (props) => props && props.enabled ? 'visible' : 'hidden'
    },
    '&:hover $innerWrapper': {
      padding: (props) => props && props.enabled ? blockHighlight.margin : 1,
      border: (props) => props && props.enabled ? blockHighlight.border : 'none'
    }
  },
  innerWrapper: {
    padding: 1
  },
  actionsArea: {
    composes: 'block-actions-area',
    top: -actionsAreaHeight,
    zIndex: zIndexes.editableBlockActionsArea
  }
}

export const useStyles = createUseStyles(style)
